import { Component, OnInit, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { WorkflowStep, StepType } from 'app/models/workflow-step';
import { FormGroup } from '@angular/forms';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { Router } from '@angular/router';
import { WorkflowWizardService } from 'app/services/workflow-wizard.service';

@Component({
  selector: 'app-step-details',
  templateUrl: './step-details.component.html',
  styleUrls: ['./step-details.component.scss']
})
export class StepDetailsComponent implements OnInit {
  
  @Output() hideModal: EventEmitter<any> = new EventEmitter<any>();
  @Output() stepDeleted: EventEmitter<any> = new EventEmitter<any>();
  
  @ViewChild('stepDetailsModal') stepDetailsModal: ModalDirective;

  currentStepFormGroup: FormGroup;

  constructor(public workflowWizardService: WorkflowWizardService,
              private _router: Router) { }

  ngOnInit() {
    this.currentStepFormGroup = null;
  }

  show(currentStepFormGroup: FormGroup) {
    this.currentStepFormGroup = currentStepFormGroup;
    if (!this.stepDetailsModal.isShown)
      this.stepDetailsModal.show();
  }

  hide() {
    if (this.stepDetailsModal.isShown)
      this.stepDetailsModal.hide();
  }

  getDueAfter(due_after: number) {
    let days = Math.floor(due_after / 24);
    let hours = due_after % 24;
    return ((days !== 0)? days + " day(s) ": '') + ((hours !== 0)? hours + " hour(s)": ''); 
  }

  currentStepTargetsString() {
    if (this.currentStepFormGroup.controls['workflow_step_type_id'].value == StepType.APPROVAL)
      return 'Approver(s)';
    else if (this.currentStepFormGroup.controls['workflow_step_type_id'].value == StepType.REVIEW)
      return 'Reviewer(s)';
    
    return 'Assignee(s)';
  }

  onEditStep() {
    this.hide();
    this.workflowWizardService.currentStep = this.currentStepFormGroup;
    this.workflowWizardService.currentStepURL = this.workflowWizardService.WIZARD_NEW_STEP;
    this._router.navigateByUrl(`${this.workflowWizardService.baseURL}${this.workflowWizardService.WIZARD_NEW_STEP}`);
  }
}
